module.exports = __webpack_public_path__ + "img/caas3-m@2.0c702d33.webp";